declare namespace $ {

	type $mol_view__sub_exso_sheets_dashboard_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_exso_sheets_dashboard_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_exso_sheets_dashboard_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_exso_sheets_dashboard_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_exso_sheets_dashboard_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_row__sub_exso_sheets_dashboard_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_row['sub'] >
	>
	type $mol_view__sub_exso_sheets_dashboard_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_exso_sheets_dashboard_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__attr_exso_sheets_dashboard_9 = $mol_type_enforce<
		({ 
			'progress_type': ReturnType< $exso_sheets_dashboard['site_progress_type'] >,
		}) 
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__sub_exso_sheets_dashboard_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_row__sub_exso_sheets_dashboard_11 = $mol_type_enforce<
		ReturnType< $exso_sheets_dashboard['site_progresses'] >
		,
		ReturnType< $mol_row['sub'] >
	>
	type $mol_row__sub_exso_sheets_dashboard_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_row['sub'] >
	>
	type $mol_view__sub_exso_sheets_dashboard_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $exso_sheets_dashboard_row__label_exso_sheets_dashboard_14 = $mol_type_enforce<
		ReturnType< $exso_sheets_dashboard['site_stat_label'] >
		,
		ReturnType< $exso_sheets_dashboard_row['label'] >
	>
	type $exso_sheets_dashboard_row__value_exso_sheets_dashboard_15 = $mol_type_enforce<
		ReturnType< $exso_sheets_dashboard['site_stat_value'] >
		,
		ReturnType< $exso_sheets_dashboard_row['value'] >
	>
	type $exso_sheets_dashboard_row__label_exso_sheets_dashboard_16 = $mol_type_enforce<
		ReturnType< $exso_sheets_dashboard['site_plan_label'] >
		,
		ReturnType< $exso_sheets_dashboard_row['label'] >
	>
	type $exso_sheets_dashboard_row__value_exso_sheets_dashboard_17 = $mol_type_enforce<
		ReturnType< $exso_sheets_dashboard['site_plan_value'] >
		,
		ReturnType< $exso_sheets_dashboard_row['value'] >
	>
	type $mol_list__attr_exso_sheets_dashboard_18 = $mol_type_enforce<
		({ 
			'progress_type': ReturnType< $exso_sheets_dashboard['site_progress_type'] >,
			'stat_type': ReturnType< $exso_sheets_dashboard['stat_type'] >,
		}) 
		,
		ReturnType< $mol_list['attr'] >
	>
	type $mol_list__style_exso_sheets_dashboard_19 = $mol_type_enforce<
		({ 
			'--width': ReturnType< $exso_sheets_dashboard['site_progress_style'] >,
		})  & ReturnType< $mol_list['style'] >
		,
		ReturnType< $mol_list['style'] >
	>
	type $mol_list__rows_exso_sheets_dashboard_20 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_row__sub_exso_sheets_dashboard_21 = $mol_type_enforce<
		ReturnType< $exso_sheets_dashboard['site_stats'] >
		,
		ReturnType< $mol_row['sub'] >
	>
	type $mol_list__rows_exso_sheets_dashboard_22 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_link__arg_exso_sheets_dashboard_23 = $mol_type_enforce<
		ReturnType< $exso_sheets_dashboard['site_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__sub_exso_sheets_dashboard_24 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_row__sub_exso_sheets_dashboard_25 = $mol_type_enforce<
		ReturnType< $exso_sheets_dashboard['sites_list'] >
		,
		ReturnType< $mol_row['sub'] >
	>
	type $mol_section__title_exso_sheets_dashboard_26 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_section['title'] >
	>
	type $mol_section__content_exso_sheets_dashboard_27 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_section['content'] >
	>
	export class $exso_sheets_dashboard extends $mol_page {
		Logo_content( ): $exso_logo
		Logo( ): $mol_view
		Stat_icon( id: any): $mol_icon_pickaxe
		Card_icon( id: any): ReturnType< $exso_sheets_dashboard['Stat_icon'] >
		stat_title( id: any): string
		Card_title( id: any): $mol_view
		stat_value( id: any): string
		Card_value( id: any): $mol_view
		Card_column( id: any): $mol_list
		Card( id: any): $mol_view
		cards( ): readonly(any)[]
		Cards( ): $mol_row
		site_arg( id: any): Record<string, any>
		site_name( id: any): string
		Site_name( id: any): $mol_view
		site_meta( id: any): string
		Site_title( id: any): $mol_list
		site_progress_type( id: any): string
		Site_progress_icon( id: any): $mol_icon_pickaxe
		site_progress_percent( id: any): string
		Site_progress( id: any): $mol_view
		site_progresses( id: any): readonly(any)[]
		Site_progresses( id: any): $mol_row
		Site_head( id: any): $mol_row
		stat_type( id: any): string
		site_progress_style( id: any): string
		Site_stat_icon( id: any): $mol_icon_pickaxe
		site_stat_title( id: any): string
		Site_stat_title( id: any): $mol_view
		fact_label( ): string
		site_stat_label( id: any): ReturnType< $exso_sheets_dashboard['fact_label'] >
		site_stat_value( id: any): string
		Site_stat_item( id: any): $exso_sheets_dashboard_row
		site_stat_items( id: any): readonly(any)[]
		plan_label( ): string
		site_plan_label( id: any): ReturnType< $exso_sheets_dashboard['plan_label'] >
		site_plan_value( id: any): string
		Site_plan_item( id: any): $exso_sheets_dashboard_row
		site_plan_items( id: any): readonly(any)[]
		Site_stat( id: any): $mol_list
		site_stats( id: any): readonly(any)[]
		Site_stats( id: any): $mol_row
		Site_content( id: any): $mol_list
		Site( id: any): $mol_link
		sites_list( ): readonly(any)[]
		Sites_list( ): $mol_row
		Sites( ): $mol_section
		date_moment( ): $mol_time_moment
		shifts( ): readonly($exso_sheets_shift)[]
		slice_shifts( ): readonly($exso_sheets_shift)[]
		month_shifts( ): readonly($exso_sheets_shift)[]
		blowings( ): readonly($exso_sheets_blowing)[]
		plans( ): readonly($exso_sheets_plan)[]
		title_content( ): readonly(any)[]
		stats( ): readonly(any)[]
		body( ): readonly(any)[]
	}
	
	type $mol_view__sub_exso_sheets_dashboard_row_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_exso_sheets_dashboard_row_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $exso_sheets_dashboard_row extends $mol_view {
		label( ): string
		Label( ): $mol_view
		value( ): string
		Value( ): $mol_view
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=dashboard.view.tree.d.ts.map